import { useI18n } from 'i18n-utils'
import type { FormRules } from 'element-plus'

export function useCommonFormRules() {
  const { t } = useI18n()
  const pwdRules = reactive<FormRules>({
    pwd: [
      { required: true, message: t('请输入密码'), trigger: 'change' },
      {
        min: 6,
        max: 20,
        message: t('密码长度为6-20位字符'),
        trigger: 'change',
      },
      {
        trigger: 'change',
        validator: (rule: any, value: string, callback: any) => {
          const chineseReg = /[\u4e00-\u9fa5]/
          if (chineseReg.test(value)) {
            callback(new Error(t('密码不能包含中文')))
            return
          }
          if (value.includes(' ')) {
            callback(new Error(t('密码不能包含空格')))
            return
          }
          const numberReg = /^\d+$/
          if (numberReg.test(value)) {
            callback(new Error(t('密码不能为纯数字')))
            return
          }
          const letterReg = /^[a-zA-Z]+$/
          if (letterReg.test(value)) {
            callback(new Error(t('密码不能为纯字母')))
            return
          }
          callback()
        },
      },
    ],
  })

  return { pwdRules }
}
